import React, { useState, useEffect } from 'react'
import linkifyHtml from 'linkify-html'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import callAPI from '../../../helpers/callAPI'

const Restrictions = ({ campaignId, showSystemMessage, refetch, trafficTypes, restrictions, countries, ipFilteringFlag, trackingType, redirects, reversalCriteria, cap, paymentDelay }) => {
    const [paymentDelayDays, setPaymentDelayDays] = useState(paymentDelay?.delay || '')
    const [paymentDelayMode, setPaymentDelayMode] = useState(paymentDelay?.mode || 'END_OF_MONTH')
    const [isUpdating, setIsUpdating] = useState(false)

    useEffect(() => {
        if (paymentDelay) {
            setPaymentDelayDays(paymentDelay.delay || '')
            setPaymentDelayMode(paymentDelay.mode || 'END_OF_MONTH')
        }
    }, [paymentDelay])

    let countryArray = countries.map((country) => country.country_name)

    // May be used in the future for editing payment delay
    // const updatePaymentDelay = async (delay, mode) => {
    //     if (isUpdating) return
    //     setIsUpdating(true)
    //     const trackingData = {
    //         payment_delay: {
    //             delay: delay,
    //             mode: mode
    //         }
    //     }
    //     const result = await callAPI(`campaign/${campaignId}/paymentDelay`, 'PUT', trackingData)
    //     if (result.success) {
    //         showSystemMessage('success', 'Payment delay updated successfully')
    //         if (refetch) {
    //             refetch()
    //         }
    //     } else {
    //         showSystemMessage('error', result.errors?.message || 'Error updating payment delay')
    //         setPaymentDelayDays(paymentDelay?.delay || '')
    //         setPaymentDelayMode(paymentDelay?.mode || 'END_OF_MONTH')
    //     }
    //     setIsUpdating(false)
    // }
    // const handleDelayChange = (e) => {
    //     const value = e.target.value
    //     if (!isNaN(value) || value === '') {
    //         setPaymentDelayDays(value)
    //     }
    // }
    // const handleModeChange = (e) => {
    //     setPaymentDelayMode(e.target.value)
    // }
    // const handleSaveDelay = () => {
    //     updatePaymentDelay(paymentDelayDays, paymentDelayMode)
    // }

    const delayNum = Number(paymentDelayDays)
    const delayModeLabel = paymentDelayMode ? String(paymentDelayMode).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : ''
    const delayLabel = delayNum === 1 ? 'day' : 'days'

    return (
        <div className="card mb-2">
            <div className="align-items-center p-2 card-header">
                <div className="font-weight-bold float-left">Restrictions</div>
            </div>
            <div className="card-body p-0">
                <table className="table table-card table-striped table-hover m-0">
                    <tbody className="m-0">                        
                        <tr>
                            <td className="border-top-0">Reversal Criteria</td>
                            <td className="border-top-0 w-75">{reversalCriteria.name}</td>
                        </tr>
                        {delayNum > 0 && ( 
                            <tr>
                                <td align="left">Payment Delay</td>
                                <td>{delayNum} {delayLabel} from {delayModeLabel}</td>
                            </tr>
                        )}
                        {redirects.expired_redirect_id !== 0 && ( 
                            <tr>
                                <td>Cancelled / Hit Cap Redirect</td>
                                <td>
                                    <Link to={`/campaign/${redirects.expired_redirect_id}`}>{redirects.expired_redirect_name}</Link> ({redirects.expired_redirect_id})
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>Daily cap per affiliate</td>
                            <td>{cap.daily === -1 ? 'Unlimited' : cap.daily}</td>
                        </tr>
                        <tr>
                            <td>Countries</td>
                            <td>{ipFilteringFlag ? countryArray.join(', ') : 'All countries allowed'}</td>
                        </tr>
                        {trackingType === 'C' && (
                            <tr>
                                <td>Web Enabled</td>
                                <td>{restrictions}</td>
                            </tr>
                        )}
                        {trafficTypes.allow_solo_emails_flag && (
                            <tr>
                                <td>Email Usage Rules</td>
                                <td>
                                    <span dangerouslySetInnerHTML={{ __html: linkifyHtml(restrictions.email_usage_rules ? restrictions.email_usage_rules : '') }} />
                                </td>
                            </tr>
                        )}
                        {trafficTypes.search_flag && (
                            <tr>
                                <td>Search Restrictions</td>
                                <td>
                                    <span dangerouslySetInnerHTML={{ __html: linkifyHtml(restrictions.search_restrictions ? restrictions.search_restrictions : '') }} />
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Restrictions
